import { AttentionType } from './globalEnums';

export const attentionMessages = {
    [AttentionType.quotaHigh]: 'Site size is reaching quota limit',
    [AttentionType.quotaExceeded]: 'Quota limit is exceeded',
    [AttentionType.ownerMissing]: 'Administrator is missing',
    [AttentionType.expirationSoon]: 'Your site will expire soon',
    [AttentionType.expired]: 'Your site expired',
    [AttentionType.emptyOwner]: 'Administrator is empty',
    'keepReadOnly': 'Keep site in read-only mode'
}


// WEBPACK FOOTER //
// ./src/GlobalConst/attentionMessages.js